import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { cavityWallInsulationInstallLpBody } from "@/content/landing/cavity-wall-insulation-install";
import { breadcrumbJsonLdScript, servicesBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const LpCavityWallInsulationPage = lazyNamed(
  () => import("@/components/landing/lp-cavity-wall-insulation"),
  "LpCavityWallInsulation",
);

const PATH = "/lp/cavity-wall-insulation";
const TITLE = "Cavity Wall Insulation South Wales | PAS 2030 Certified";
const DESCRIPTION =
  "PAS 2030 certified cavity wall insulation installers in South Wales. Free technical inspection, 25-year guarantee. No-obligation quote, call 0800 009 2992.";
const BREADCRUMB_NAME = "Cavity Wall Insulation in South Wales";

export const Route = createFileRoute("/lp/cavity-wall-insulation")({
  head: () => ({
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: BREADCRUMB_NAME,
        description: DESCRIPTION,
        serviceType: "Cavity Wall Insulation",
        url: `${SITE.url}${PATH}`,
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: cavityWallInsulationInstallLpBody.faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
      breadcrumbJsonLdScript(
        servicesBreadcrumbTrail(BREADCRUMB_NAME, PATH),
      ),
    ],
  }),
  component: LpCavityWallInsulationPage,
});
